import { observer } from 'mobx-react-lite'
import { Button } from 'app/components/ui/button'
import { useDarkModeAvailable } from 'app/hooks/useDarkModeAvailable'
import { useThemeReady } from 'app/hooks/useThemeReady'
import { useUserSettingStore } from 'app/stores/StoreContext'
import type { ThemePreference } from 'app/types/theme'
import { bg } from 'lib/background'
import { APPEARANCE_THEME_SETTING, parseThemePreference } from 'lib/theme'

const OPTIONS: ReadonlyArray<{ value: ThemePreference; label: string }> = [
  { value: `light`, label: `Light` },
  { value: `dark`, label: `Dark` },
  { value: `system`, label: `System` },
]

export const AppearanceSection = observer(function AppearanceSection() {
  const enabled = useDarkModeAvailable()
  const ready = useThemeReady()
  const store = useUserSettingStore()
  if (!enabled) return null

  const current = parseThemePreference(store.settings[APPEARANCE_THEME_SETTING])

  return (
    <section aria-labelledby="appearance-heading" className="flex flex-col gap-2">
      <h2 id="appearance-heading" className="text-label-sm text-strong">
        Appearance
      </h2>
      <div role="group" aria-label="Theme" className="flex gap-2">
        {OPTIONS.map((option) => (
          <Button
            key={option.value}
            variant="toggle"
            size="sm"
            aria-pressed={current === option.value}
            disabled={!ready}
            onClick={() => bg(async () => store.save(APPEARANCE_THEME_SETTING, JSON.stringify(option.value)))}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </section>
  )
})
